import axios from "axios";
import { handleResponse } from "../../utils";
export const configService = {
  getAllCustomers,
  getActiveCustomers,
  getProjectsByCustomerId,
  getAllChannels,

  getDocInstances,

  getDocumentDeliveryData,

  activateCustomer,
  deactivateCustomer,

  updateCustomer,
  insertCustomer,

  getPlatformNames,

  getCustomersByParentId,

  getLastUploadList,

  getReportsDescriptionsJson,
};

function getReportsDescriptionsJson(params) {
  return axios
    .get("Reporting/getReportsDescriptionsJson", {
      params: params,
    })
    .then((response) => response.data)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getLastUploadList(params) {
  return axios
    .get("Configuration/ldls/getuploadslist", {
      params: params,
    })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getAllCustomers() {
  return axios
    .get("Configuration/customers", { params: { showAll: true } })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getCustomersByParentId(parentGlobalId) {
  return axios
    .get("Configuration/customers", { params: { parentGlobalId } })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getActiveCustomers() {
  return axios
    .get("Configuration/customers")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getPlatformNames() {
  return axios
    .get("Configuration/platforms/list?all=true")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getProjectsByCustomerId(globalId, isExternalUser) {
  var params = isExternalUser
    ? {}
    : {
        customerid: globalId,
      };
  return axios
    .get("Configuration/customers/GetCustomer", {
      params,
    })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getAllChannels(params) {
  return axios
    .get("Configuration/channels", {
      params: params,
      //headers: {'Token': axios.defaults.headers.common['PortalToken']},
    })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getDocInstances(docId) {
  let params = {
    DocNodeId: docId,
  };
  return axios
    .get("Tracking/DocumentInstances", { params: params })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function getDocumentDeliveryData(params) {
  return axios
    .get("Tracking/getparkeddocumentbbs", { params: params })
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function activateCustomer(globalId) {
  return axios
    .post("Configuration/customers/" + globalId + "/activate")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function deactivateCustomer(globalId) {
  return axios
    .post("Configuration/customers/" + globalId + "/deactivate")
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function updateCustomer(params) {
  return axios
    .put("Configuration/customers/update", params)
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}

function insertCustomer(params) {
  return axios
    .post("Configuration/customers/insert", params)
    .then(handleResponse)
    .catch((error) => {
      return Promise.reject(error);
    });
}
